import { useListState } from '@mantine/hooks';
import { useContext, useEffect, useState } from 'react';
import { AgencyTemplateDTO, EmailContent, EmailFileDto } from '../../Types/MessageT';
import { BookingState, RecommendationDto, RecommendationMailType } from '../../Types/RecommendationT';
import { AgencyTemplateS } from '../AgencyTemplateS';
import { ProfileContext } from '../Context/ProfileContext';
import { EventContext } from '../Context/EventContext';
import { RecommendationS } from '../RecommendationS';
import { ViolationContext } from '../Context/ViolationContext';
import { LicenceS } from '../LicenceS';

// eslint-disable-next-line import/prefer-default-export
export const useRecommendationMail = (
  type: RecommendationMailType,
  recommendation: RecommendationDto | null,
  selectedTemplate?: AgencyTemplateDTO,
  bookingState?: BookingState,
) => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { profile } = useContext(ProfileContext);
  const { dates } = useContext<any>(EventContext);
  const { alias } = profile ?? {};
  const [mail, setMail] = useState<EmailContent>({ subject: '', message: '' });
  const [attachments, handlers] = useListState<EmailFileDto>([]);
  const { subject, message } = mail;
  const isFilled = subject !== '' && message !== '';

  useEffect(() => {
    if (recommendation) {
      const recommendationDates = RecommendationS.extractRecommendationDates(dates, recommendation);
      const defaultSubject = AgencyTemplateS.resolveDefaultSubject(type, recommendationDates, alias, bookingState);
      setMail((prev) => ({ ...prev, subject: defaultSubject }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alias, type, recommendation]);

  useEffect(() => {
    if (selectedTemplate) {
      executeWithLicenceCheck(LicenceS.Restrictions.AGENCY_TEMPLATES, () => {
        setMail(selectedTemplate);
        handlers.setState(selectedTemplate.attachments);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTemplate]);

  const updateProp = (patch: Partial<EmailContent>) => setMail((prev) => ({ ...prev, ...patch }));

  return {
    mail,
    subject,
    message,
    isFilled,
    attachments,
    handlers,
    updateProp,
  };
};
